import * as React from 'react';
import { useState } from 'react';
import Box from '@mui/material/Box';
import { Grid, Button, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import styles from './logicalChooser.module.scss'
import Options from './Options';
import { v4 as uuid } from 'uuid';
import resetIcon from '../../assets/resetIcon.svg'

const LogicalChooser = ({ data, parentState = [], updateParentState, optionHeader, operatorSub, extraRender }) => {
    const [state, setState] = React.useState(parentState)
    const [uuids, setUuids] = React.useState([])
    const [ isDisabled, setIsDisabled ] = useState(false)

    if (uuids?.length !== state?.attributes?.length) {
        let newUuids = [...uuids]
        state.attributes.forEach((item, index) => {
            newUuids[index] = uuid()
        })
        setUuids([...newUuids])
    }

    const handleChange = (event, newAlignment) => {
        setState(prevState => ({ ...prevState, operator: newAlignment }))
    };
    const handleAddAttribute = () => {
        uuids.push(uuid())
        const newAttributes = [...state.attributes]
        newAttributes.push({})
        setState(prevState => ({ ...prevState, attributes: newAttributes }))
    }
    const handleRemoveAttribute = (index) => {
        uuids.splice(index, 1)
        const newAttributes = [...state.attributes]
        newAttributes.splice(index, 1)
        setState(prevState => ({ ...prevState, attributes: newAttributes }))
    }
    const updateAttribute = (index, attribute) => {
        const newAttributes = [...state.attributes]
        newAttributes[index] = attribute
        setState(prevState => ({ ...prevState, attributes: newAttributes }))
    }
    const handleResetFilters = () => {
        setState({ 
            operator: "AND", 
            attributes: [{
                attribute: "",
                operator:"",
                value: ""
        }]})
        setUuids([])
    }

    React.useEffect(() => {
        updateParentState.attributes([...state.attributes])
        updateParentState.operator(state.operator)
        if (state.attributes.length === 0) {
            handleAddAttribute()
        }
        const lastAttribute = state.attributes[state.attributes.length - 1]
        if(lastAttribute.attribute && lastAttribute.operator && lastAttribute.value) {
            setIsDisabled(false)
        }else {
            setIsDisabled(true)
        }
    }, [state.attributes, state.operator])

    return (
        <Box className={styles.logicalChooserContainer}>
            <Grid container className={styles.optionOperator}>
                <Grid item xs={12}>
                    <ToggleButtonGroup
                        value={state.operator}
                        exclusive
                        onChange={handleChange}
                    >
                        <ToggleButton className={`${styles.btn} ${state.operator == "AND" ? styles.selected : ''}`} value="AND">AND</ToggleButton>
                        <ToggleButton className={`${styles.btn} ${state.operator == "OR" ? styles.selected : ''}`} value="OR">OR</ToggleButton>
                    </ToggleButtonGroup>
                </Grid>
                <Grid item xs={12}>
                    <Typography className={styles.operatorSub}>{operatorSub}</Typography>
                </Grid>
            </Grid>
            {state.attributes.map((item, index) => <Options key={uuids[index]} data={data} optionHeader={optionHeader} parentState={item} index={index} updateParentState={updateAttribute} remove={handleRemoveAttribute} total={state.attributes.length} operator={state.operator} />)}
            <Grid container className={styles.buttonContainer}>
                <Grid item xs={12}>
                    <Button className={`${styles.button} ${isDisabled ? styles.btnGray : "" }`} variant='outlined' onClick={handleAddAttribute} disabled={isDisabled}>
                        + Add another attribute</Button>
                </Grid>
                <Grid container item xs={12} justifyContent="space-between" sx={{ marginTop: "92px" }}>
                    <Grid item xs={3}>
                        <Button className={`${styles.btn} ${styles.resetBtn}`} startIcon={<img src={resetIcon} />} onClick={handleResetFilters}>Reset All Filters</Button>
                    </Grid>
                    {extraRender}
                </Grid>
            </Grid>
        </Box>
    );
}

export default LogicalChooser
